import React, { useEffect, useState } from 'react';
import styles from './DialogList.module.css'; 
import { sendDialogData } from '../../api/fetchDialogs'; // Импортируем функцию для общения с сервером
import Neirotopics from '../../components/Neirotopics/Neirotopics';
import { useDelayedLoading } from '../../hooks/useDelayedLoading';
import Loading from '../../components/Loading/Loading';
import { useAppConfig } from '../../context/AppConfigContext';

function DialogList({ onDialogSelect, userId }) {
  const [topics, setTopics] = useState([]); // Состояние для хранения данных диалогов
  const [loading, setLoading] = useState(true); // Состояние для индикатора загрузки
  const [error, setError] = useState(null); // Состояние для ошибок
  const { t } = useAppConfig();
  const showLoading = useDelayedLoading(loading, 3000);

  useEffect(() => {
    sendDialogData({ userId })
      .then(setTopics)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);    
  
  if (showLoading) { return <Loading />; }

  if (error) {
    return <div>Error: {error}</div>;
  }
  //console.log("Данные диалогов", topics);

  return (
    <Neirotopics data={topics} onSelect={onDialogSelect} neirotitle={t.dialog.menu} source="dialogs"/>
  );
}

export default DialogList;
